import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { ExternalSourcingFunnel, HttpResponse } from "@/types";

export function useGetExternalSourcingFunnel() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["external-sourcing-funnel", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/sourcing-request-rated-profiles/funnel-counts`;
      const res = await guacHttpClient.get<
        ExternalSourcingFunnel,
        HttpResponse<ExternalSourcingFunnel>
      >(path);
      return res.data;
    },
  });
}
